export const realEstateAwards = [
  'Real Estate Company of the Year (Global)',
  'Best International Real Estate Developer',
  'Best Emerging Real Estate Brand',
  'Most Innovative Real Estate Company',
  'Best Real Estate Investment Firm',
  'Best Residential Development (International)',
  'Best Commercial Project of the Year',
  'Best Mixed-Use Development',
  'Best Luxury Real Estate Project',
  'Best Affordable Housing Project',
  'Best Urban Regeneration Project',
  'Best Hospitality or Hotel Development',
  'Best Sustainable Real Estate Project',
  'Green Developer of the Year',
  'Best Use of Technology in Real Estate',
  'PropTech Company of the Year',
  'Real Estate CEO of the Year',
  'Young Real Estate Leader of the Year',
  'Real Estate Woman of the Year',
  'Lifetime Achievement in Real Estate',
  'Best Real Estate Marketing Campaign',
  'Best Property Branding Strategy',
  'Best Real Estate Website or Platform',
  'Most Innovative Property Listing Service',
  'Best Real Estate Company – Europe',
  'Best Real Estate Company – Asia',
  'Best Real Estate Company – MENA',
  'Best Real Estate Company – Americas',
  'Best Real Estate Company – Africa'
];

export const beautyAwards = [
  'Beauty Brand of the Year',
  'Best International Skincare Brand',
  'Best Haircare Brand',
  'Best Makeup Brand',
  'Best Organic or Natural Beauty Brand',
  'Most Innovative Beauty Product',
  'Best Emerging Beauty Brand',
  'Best Luxury Beauty Brand',
  'Best Sustainable Beauty Brand',
  'Green Beauty Initiative of the Year',
  'Best Inclusive Beauty Brand',
  'Beauty Entrepreneur of the Year',
  'Best Beauty Product Packaging',
  'Best Beauty Tech Innovation',
  'Best Salon or Spa Experience',
  'Best Fragrance of the Year',
  'Best Cruelty-Free Brand',
  'Best Vegan Beauty Brand',
  'Best Beauty Marketing Campaign',
  'Best Beauty Influencer Collaboration',
  'Best Online Beauty Retailer',
  'Best Beauty Brand Website or App',
  'Lifetime Achievement in the Beauty Industry',
  'Best Beauty Brand – Europe',
  'Best Beauty Brand – Asia',
  'Best Beauty Brand – MENA',
  'Best Beauty Brand – Americas',
  'Best Beauty Brand – Africa'
];

export const touristAwards = [
  'Tourism Destination of the Year',
  'Best Emerging Travel Destination',
  'Best Cultural Tourism Experience',
  'Best Adventure Tourism Provider',
  'Best Eco-Tourism Destination',
  'Best Sustainable Tourism Initiative',
  'Best Luxury Travel Experience',
  'Best Budget Travel Service',
  'Best Tour Operator',
  'Best Travel Agency',
  'Best Airline for International Travel',
  'Best Boutique Hotel',
  'Best Resort or Spa',
  'Best Urban Hotel',
  'Best Rural or Nature Lodge',
  'Best Business Hotel',
  'Best Hotel Interior Design',
  'Best Hotel Chain (International)',
  'Best Hotel Customer Service',
  'Best New Hotel Opening',
  'Best Hotel for Digital Nomads',
  'Best Hotel Sustainability Program',
  'Best Travel Influencer Campaign',
  'Best Digital Travel Platform',
  'Best Travel Booking App or Website',
  'Best Heritage Conservation in Tourism',
  'Best Culinary Tourism Experience',
  'Tourism Entrepreneur of the Year',
  'Best Medical or Wellness Tourism Provider',
  'Lifetime Achievement in Tourism',
  'Best Tourism Board – Europe',
  'Best Tourism Board – Asia',
  'Best Tourism Board – MENA',
  'Best Tourism Board – Americas',
  'Best Tourism Board – Africa'
];

export const influencerAwards = [
  'Influencer of the Year',
  'Best Beauty Influencer',
  'Best Fashion Influencer',
  'Best Travel Influencer',
  'Best Fitness Influencer',
  'Best Lifestyle Influencer',
  'Best Food Influencer',
  'Best Tech Influencer',
  'Best Gaming Influencer',
  'Best Parenting Influencer',
  'Best Health & Wellness Influencer',
  'Best Finance & Business Influencer',
  'Best Educational Content Creator',
  'Best Activism or Social Impact Influencer',
  'Breakout Influencer of the Year',
  'Best TikTok Creator',
  'Best Instagram Influencer',
  'Best YouTube Channel',
  'Best Influencer Marketing Campaign',
  'Most Engaging Influencer',
  'Most Authentic Influencer',
  'Best International Influencer',
  'Best Local/Niche Influencer',
  'Influencer Entrepreneur of the Year',
  'Best Influencer-Led Brand',
  'Best Influencer Collaboration',
  'Young Influencer Entrepreneur of the Year',
  'Female Influencer Entrepreneur of the Year',
  'Male Influencer Entrepreneur of the Year',
  'Creative Visionary Award',
  'Lifetime Achievement in Influencer Industry'
];

export const bankingAwards = [
  'The Best Bank',
  'The Best Mobile Banking App',
  'The Best Internet Banking',
  'Innovation of the Year',
  'The Best Customer Service',
  'The Best Current Account Provider',
  'The Best Corporate Banking Services',
  'The Best Credit Card',
  'The Best Personal Provider',
  'The Best Corporate Loan Provider',
  'The Best Asset Management Options',
  'The Best Use of IT in Corporate Banking',
  'The Best Use of IT in Treasury and Capital Markets',
  'The Best Use of AI',
  'The Best Use of Biometrics',
  'The Tech Team of the Year'
];

export const forexAwards = [
  'The Most Trusted Forex Broker',
  'The Startup Of The Year',
  'The Best IB Program',
  'The Best Affiliate program',
  'The Best CFD Broker',
  'The Best Cryptocurrency Broker',
  'The Best Customer Support',
  'The Best Educational Program',
  'The Best Execution Broker',
  'The Best Forex Broker',
  'The Best Forex Copy Trading Platform',
  'The Best Forex EA Solutions',
  'The Best FX Blog',
  'The Best Investment Options',
  'The Best Islamic FX Account',
  'The Best Liquidity Solution',
  'The Best Market Analysis',
  'The Best Mobile App',
  'The Best Social Trading Network',
  'The Best Trading Conditions',
  'The Best Trading Platform',
  'The Best White Label Solutions',
  'The Best Withdrawal Options',
  'The Fastest Growing Broker',
  'The Most Innovative Broker'
];

export const insuranceAwards = [
  'Life Insurance Company of the Year',
  'General Insurance Company of the Year',
  'Digital Insurer of the Year',
  'Health Insurance Company of the Year',
  'Educational Service Provider of the Year',
  'Broker of the Year',
  'Reinsurer of the Year',
  'InsurTech of the Year',
  'Technology Initiative of the Year',
  'Service Provider of the Year',
  'The Travelers Award for Brokerage of the Year',
  'The Versature Award for Digital Innovator of the Year',
  'P&C Insurer of the Year',
  'The Advocis Award for Life and Health Insurer of the Year',
  'The Armour Insurance Award for MGA of the Year',
  'The Winmar Award for Excellence in Claims Service',
  'Excellence in Risk Management',
  'Insurance Industry Employer of Choice',
  'Best Service Provider',
  'Best Advertising Campaign',
  'The Cansure Award for Insurance Broker of the Year',
  'The PAL Insurance Brokers Award for Young Achiever of the Year',
  'The Lowest Rates Award for CEO of the Year',
  'The Empire Life Award for Life and Health Advisor of the Year',
  'Business Development Manager of the Year',
  'Underwriter of the Year'
];

export const stockBrokerAwards = [
  'The Best Customer Service',
  'The Best International Share Dealing Service',
  'The Best REIT',
  'The Best ETF Provider',
  'The Best Investment Trust',
  'The Best Fund',
  'The Best Investor Tools/ Research',
  'The Best Share Registrar',
  'The Best Company for Shareholder Communication',
  'AIM Company of the Year',
  'The Best Stocks & Shares ISA Provider',
  'The Best Trading Tools and Research',
  'The Best Advisory Service',
  'The Best Online Investment Platform',
  'The Best Wealth Manager',
  'The Best Professional Trading Platform',
  'The Best Mobile/Tablet Application',
  'The Best Trading Conditions',
  'The Best CFD Provider',
  'The Best Spread Betting Provider',
  'The Best Execution-Only Broker',
  'The Best Binary Broker Award',
  'The Best US Broker Award'
];